import { titleBlockSchema } from '../../blocks/title/index.js';
import { ratingBlockSchema } from '../../blocks/rating/index.js';
import { priceBlockSchema } from '../../blocks/price/index.js';
import { variantPickerBlockSchema } from '../../blocks/variant-picker/index.js';
import { quantityBlockSchema } from '../../blocks/quantity/index.js';
import { codFormBlockSchema } from '../../blocks/cod-form/index.js';
import { buyButtonsBlockSchema } from '../../blocks/buy-buttons/index.js';
import { descriptionBlockSchema } from '../../blocks/description/index.js';
import { collapsibleRowBlockSchema } from '../../blocks/collapsible-row/index.js';
import { textBlockSchema } from '../../blocks/text/index.js';
import { headingBlockSchema } from '../../blocks/heading/index.js';
import { imageBlockSchema } from '../../blocks/image/index.js';
import { buttonBlockSchema } from '../../blocks/button/index.js';
import { dividerBlockSchema } from '../../blocks/divider/index.js';
import { shippingCheckpointsBlockSchema } from '../../blocks/shipping-checkpoints/index.js';
import { urgencyBlockSchema } from '../../blocks/urgency/index.js';
import { urgencyBoxBlockSchema } from '../../blocks/urgency-box/index.js';
import { estimatedShippingBlockSchema } from '../../blocks/estimated-shipping/index.js';
import { inventoryBlockSchema } from '../../blocks/inventory/index.js';
import { paymentBadgesBlockSchema } from '../../blocks/payment-badges/index.js';
import { emojiBenefitsBlockSchema } from '../../blocks/emoji-benefits/index.js';
import { stickyAtcBlockSchema } from '../../blocks/sticky-atc/index.js';
import { skuBlockSchema } from '../../blocks/sku/index.js';
import { shareButtonBlockSchema } from '../../blocks/share-button/index.js';
import { viewDetailsBlockSchema } from '../../blocks/view-details/index.js';
import { sizingChartBlockSchema } from '../../blocks/sizing-chart/index.js';
import { sizeRowBlockSchema } from '../../blocks/size-row/index.js';
import { tabsBlockSchema } from '../../blocks/tabs/index.js';
import { complementaryBlockSchema } from '../../blocks/complementary/index.js';
import { iconWithTextBlockSchema } from '../../blocks/icon-with-text/index.js';
import { iconWithContentBlockSchema } from '../../blocks/icon-with-content/index.js';
import { textWithIconBlockSchema } from '../../blocks/text-with-icon/index.js';
import { benefitPanelBlockSchema } from '../../blocks/benefit-panel/index.js';
import { benefitRowBlockSchema } from '../../blocks/benefit-row/index.js';
import { offerCardBlockSchema } from '../../blocks/offer-card/index.js';
import { volumeTiersBlockSchema } from '../../blocks/volume-tiers/index.js';
import { reviewBlockSchema } from '../../blocks/review/index.js';
/**
 * Child block types a buy-box column accepts (Shrine `main-product_details` accepts list, curated): the
 * buy-box pieces + the generic content blocks (text/heading/image/button/divider) for free-form copy + the
 * Shrine conversion blocks (shipping-checkpoints, urgency, estimated-shipping, inventory, payment-badges,
 * emoji-benefits, sticky-atc).
 */
export const BUY_BOX_ACCEPTS = [
    'title',
    'rating',
    'price',
    'variant-picker',
    'quantity',
    'cod-form',
    'buy-buttons',
    'description',
    'collapsible-row',
    'text',
    'heading',
    'image',
    'button',
    'divider',
    'shipping-checkpoints',
    'urgency',
    'urgency-box',
    'estimated-shipping',
    'inventory',
    'payment-badges',
    'emoji-benefits',
    'sticky-atc',
    'sku',
    'share-button',
    'view-details',
    'sizing-chart',
    'tabs',
    'complementary',
    'icon-with-text',
    'icon-with-content',
    'text-with-icon',
    // Top-tier PDP buy-box anatomy blocks (Shokz-class reference).
    'benefit-panel',
    'offer-card',
    // Standalone bundle/volume selector (exposes the quantity-offer engine outside cod-form).
    'volume-tiers',
    // Single customer review (avatar + stars + quote) above the title.
    'review',
];
/**
 * Details — Shrine's `main-product_details` STATIC child: the product-info column. Holds the buy-box
 * block stack (title · rating · price · variant · quantity · cod-form · description · collapsible-row).
 * The standalone `buy-box` section instantiates the SAME child, under its own label.
 */
export const detailsBlockSchema = {
    type: 'details',
    name: 'Details',
    fields: [],
    accepts: [...BUY_BOX_ACCEPTS],
};
/** Every block schema a buy-box column can instantiate, in the order the rail lists them. */
export const buyBoxBlockSchemas = [
    titleBlockSchema,
    ratingBlockSchema,
    priceBlockSchema,
    variantPickerBlockSchema,
    quantityBlockSchema,
    codFormBlockSchema,
    buyButtonsBlockSchema,
    descriptionBlockSchema,
    collapsibleRowBlockSchema,
    textBlockSchema,
    headingBlockSchema,
    imageBlockSchema,
    buttonBlockSchema,
    dividerBlockSchema,
    shippingCheckpointsBlockSchema,
    urgencyBlockSchema,
    urgencyBoxBlockSchema,
    estimatedShippingBlockSchema,
    inventoryBlockSchema,
    paymentBadgesBlockSchema,
    emojiBenefitsBlockSchema,
    stickyAtcBlockSchema,
    skuBlockSchema,
    shareButtonBlockSchema,
    viewDetailsBlockSchema,
    sizingChartBlockSchema,
    sizeRowBlockSchema,
    tabsBlockSchema,
    complementaryBlockSchema,
    iconWithTextBlockSchema,
    iconWithContentBlockSchema,
    textWithIconBlockSchema,
    benefitPanelBlockSchema,
    benefitRowBlockSchema,
    offerCardBlockSchema,
    volumeTiersBlockSchema,
    reviewBlockSchema,
];
//# sourceMappingURL=buyBoxBlocks.js.map